module.exports = __webpack_public_path__ + "static/img/deploy2.6d80b32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deploy2.png
// module id = WcGS
// module chunks = 1